import type { LocalSession } from "@/lib/session";

const AUTH_PATHS = new Set(["/auth"]);

const PROTECTED_PREFIXES = [
  "/dashboard",
  "/issues",
  "/security",
  "/performance",
  "/alerts",
  "/events",
  "/settings"
];

export function isAuthPath(pathname: string): boolean {
  return AUTH_PATHS.has(pathname);
}

export function isProtectedPath(pathname: string): boolean {
  return PROTECTED_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}

function isOnboardingComplete(session: LocalSession): boolean {
  return Boolean(session.onboardingComplete);
}

export function resolvePostAuthDestination(
  session: LocalSession,
  fallback = "/dashboard"
): string {
  if (!isOnboardingComplete(session)) {
    return "/onboarding";
  }
  return fallback;
}
